// GENERADO por scripts/gen-abi.mjs desde out/KeelTimelock.sol/KeelTimelock.json — no editar a mano.
// Se regenera en cada build; si algo no cuadra, corre `forge build` y `npm run abi`.

export const keelTimelockAbi = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_owner",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "_guardian",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "_delay",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "_gracia",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "cancelar",
    "inputs": [
      {
        "name": "x",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "delay",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ejecutar",
    "inputs": [
      {
        "name": "destino",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "datos",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "salida",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "encolar",
    "inputs": [
      {
        "name": "destino",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "datos",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "x",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "estado",
    "inputs": [
      {
        "name": "x",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "encolada",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "cuando",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "lista",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "caducada",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "gracia",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "guardian",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "id",
    "inputs": [
      {
        "name": "destino",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "datos",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "pure"
  },
  {
    "type": "function",
    "name": "listaEspera",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "owner",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "setGuardian",
    "inputs": [
      {
        "name": "nuevo",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOwner",
    "inputs": [
      {
        "name": "nuevo",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "Cancelada",
    "inputs": [
      {
        "name": "id",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Ejecutada",
    "inputs": [
      {
        "name": "id",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "destino",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "datos",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Encolada",
    "inputs": [
      {
        "name": "id",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "destino",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "datos",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      },
      {
        "name": "cuando",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "GuardianCambiado",
    "inputs": [
      {
        "name": "guardian",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnerCambiado",
    "inputs": [
      {
        "name": "owner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "Caducada",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FalloDestino",
    "inputs": [
      {
        "name": "motivo",
        "type": "bytes",
        "internalType": "bytes"
      }
    ]
  },
  {
    "type": "error",
    "name": "NoEncolada",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoGuardian",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoOwner",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoSelf",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ParamMalo",
    "inputs": []
  },
  {
    "type": "error",
    "name": "Pronto",
    "inputs": []
  },
  {
    "type": "error",
    "name": "YaEncolada",
    "inputs": []
  }
] as const;
